import React, { useState, useRef, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FiSend } from "react-icons/fi";

export default function AiAssistantCard() {
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const chatRef = useRef();

  const handleSend = () => {
    if (!message.trim()) return;

    setChat([...chat, { text: message, type: "user" }]);
    setMessage("");

    setTimeout(() => {
      setChat((prev) => [
        ...prev,
        { text: "Got it 👍 I’ll help you with that.", type: "ai" },
      ]);
    }, 600);
  };

  // auto scroll
  useEffect(() => {
    chatRef.current?.scrollTo({
      top: chatRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [chat]);

  return (
    <Card className="ai-card">
      <Card.Body className="ai-body">

        {/* HEADER */}
        <div className="ai-header-top">
          <div className="ai-robot-box">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="8" width="18" height="12" rx="3" />
              <circle cx="9" cy="14" r="1" />
              <circle cx="15" cy="14" r="1" />
              <path d="M12 8V4" />
              <path d="M8 4h8" />
            </svg>
          </div>

          <h4 className="ai-title">How can i help you today</h4>

          <div className="ai-status">
            <span className="ai-label">AI Payroll Assistant</span>
            <span className="ai-online">● Online</span>
          </div>
        </div>

        {/* TAGS */}
        <div className="tags">
          <div className="tag full">
            Analyze top candidates for Senior Developer role
          </div>
          <div className="tag">
            Generate hiring report
          </div>
        </div>

        {/* AI BOX */}
        <div className="ai-box">
          <p className="ai-box-title">✨ AI Assistant</p>
          <p className="ai-msg">
            👋 Welcome to your AI Recruitment Assistant! I'm here to help you
          </p>
        </div>

        {/* CHAT LIST */}
        <div className="chat-list" ref={chatRef}>
          {chat.map((c, i) => (
            <div key={i} className={`msg ${c.type}`}>
              {c.text}
            </div>
          ))}
        </div>

        {/* INPUT */}
        <div className="chat-box">
          <input
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Ask me anything about Requirement"
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button onClick={handleSend}>
            <FiSend size={16} />
          </button>
        </div>

      </Card.Body>

      <style>{`

        .ai-card {
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          background: #fff;
        }

        /* FIXED HEIGHT LAYOUT */
        .ai-body {
          height: 520px;
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        /* HEADER */
        .ai-header-top {
          text-align: center;
        }

        .ai-robot-box {
          width: 60px;
          height: 60px;
          border-radius: 14px;
          background: #ff6a2a;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 10px;
        }

        .ai-title {
          font-size: 18px;
          font-weight: 700;
          color: #1f2a44;
          margin-bottom: 6px;
        }

        .ai-status {
          display: flex;
          justify-content: center;
          gap: 8px;
        }

        .ai-label {
          font-size: 13px;
          color: #6b7280;
        }

        .ai-online {
          background: #22c55e;
          color: #fff;
          font-size: 11px;
          padding: 3px 10px;
          border-radius: 20px;
        }

        /* TAGS */
        .tags {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .tag {
          background: #f3f4f6;
          padding: 8px 12px;
          border-radius: 20px;
          font-size: 12px;
          border: 1px solid #e5e7eb;
          width: fit-content;
        }

        .tag.full {
          width: 100%;
        }

        /* AI BOX */
        .ai-box {
          background: #f5f7fa;
          border-radius: 14px;
          padding: 12px;
        }

        .ai-box-title {
          color: #ff6a00;
          font-weight: 600;
          font-size: 13px;
          margin-bottom: 4px;
        }

        .ai-msg {
          font-size: 12px;
          color: #4b5563;
          margin: 0;
        }

        /* CHAT AREA (KEY FIX) */
        .chat-list {
          flex: 1;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .msg {
          padding: 6px 10px;
          font-size: 12px;
          border-radius: 10px;
          max-width: 75%;
        }

        .msg.user {
          background: #ff6a00;
          color: #fff;
          align-self: flex-end;
        }

        .msg.ai {
          background: #f3f4f6;
          color: #374151;
          align-self: flex-start;
        }

        /* INPUT */
        .chat-box {
          display: flex;
          align-items: center;
          border-radius: 25px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          padding: 4px 6px;
        }

        .chat-box input {
          flex: 1;
          border: none;
          outline: none;
          background: transparent;
          padding: 8px;
          font-size: 12px;
        }

        .chat-box button {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: none;
          background: #ff6a00;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .ai-body {
            height: 480px;
            padding: 16px;
          }
        }

      `}</style>
    </Card>
  );
}